import { PersonAddAlt1 } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Box, Dialog, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useContext, useMemo, useState } from "react";
import { AppContext } from "../../../../AppContext";
import SimpleWidgetsHeader from "../../../../components/SimpleWidgetsHeader/SimpleWidgetsHeader";
import {
    useCreateDoctypeData,
    useGetDocTypeList,
} from "../../../../shared/hooks/useDocTypesData";
import { useStyles } from "./styles";

const ExpenseClaimDialog = ({
    dialogOpen,
    onConfirm,
    onCancel,
    customerSelected,
    selectedCustomer,
}) => {
    const classes = useStyles();
    const { userInfo, company } = useContext(AppContext);
    const [submitLoading, setSubmitLoading] = useState(false);

    const { data: getEmployee } = useGetDocTypeList({
        doctype: "Employee",
        filters: [["user_id", "=", userInfo.name]],
    });

    const currentEmployee = useMemo(() => {
        if (getEmployee && getEmployee.length > 0) {
            return getEmployee[0].employee;
        }
    }, [getEmployee]);

    const [selectedExpenseClaimType, setSelectedExpenseClaimType] =
        useState("Daily Expenses");
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState("");

    const handleOnClose = () => {
        // setCustomerAddressOpen(false);
        setAmount("");
        setDescription("");
        if (onCancel) onCancel();
    };

    const createExpenseClaimMutation = useCreateDoctypeData();

    let title = "Expense Claim";

    if (selectedCustomer) {
        title += ` [ ${selectedCustomer} ]`;
    }

    const handleExpenseClaimTypeChange = (event) => {
        setSelectedExpenseClaimType(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    const handleAmountChange = (event) => {
        setAmount(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Handle form submission logic here

        const loggedInUser = userInfo.name;
        let expenses = [
            {
                expense_type: selectedExpenseClaimType,
                description: description,
                amount: amount,
                cost_center: company.cost_center, // TODO: Should we get it from ?
                default_account: `Daily Expenses - ${company.abbr}`, // TODO: Should we get it from ?
            },
        ];

        const formData = {
            expenses: expenses,
            description: description,
            employee: currentEmployee,
            payable_account: `Daily Expense Payables - ${company.abbr}`, // TODO: should we get it from  ?
            Company: company.company_name || company.name,
        };

        setSubmitLoading(true);

        createExpenseClaimMutation.mutate(
            {
                doctype: "Expense Claim",
                formData: { ...formData },
            },
            {
                onSuccess: (data) => {
                    if (onConfirm) {
                        onConfirm(data);
                        setAmount("");
                        setDescription("");
                        enqueueSnackbar(`Expense Claim Submitted!`);
                    }
                },
                onError: (error) => {
                    enqueueSnackbar(`Error: ${error.message}`, {
                        variant: "error",
                    });
                },
                onSettled: () => {
                    setSubmitLoading(false);
                },
            }
        );
    };

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={"md"}
                open={dialogOpen}
                onClose={handleOnClose}
            >
                <div className={classes.DialogWrapper}>
                    <SimpleWidgetsHeader
                        Icon={PersonAddAlt1}
                        onClose={handleOnClose}
                        title={title}
                    />
                    <div className={classes.List}>
                        <Box component="form" onSubmit={handleSubmit}>
                            <TextField
                                label="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                                fullWidth
                                margin="normal"
                                variant="standard"
                            />

                            <TextField
                                label="Amount"
                                type="number"
                                value={amount}
                                onChange={handleAmountChange}
                                fullWidth
                                margin="normal"
                                variant="standard"
                                inputProps={{ min: 0 }}
                            />

                            <LoadingButton
                                type="submit"
                                variant="contained"
                                color="primary"
                                loading={submitLoading}
                            >
                                Submit
                            </LoadingButton>
                        </Box>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default ExpenseClaimDialog;
